var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    stroke: "#007FA1",
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.80769V2.19231C20 1.80996 19.7062 1.5 19.3438 1.5L15.4062 1.5C15.0438 1.5 14.75 1.80996 14.75 2.19231V9.80769C14.75 10.19 15.0438 10.5 15.4062 10.5H19.3438C19.7062 10.5 20 10.19 20 9.80769Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 9.75C17.7892 9.75 18.125 9.41421 18.125 9C18.125 8.58579 17.7892 8.25 17.375 8.25C16.9608 8.25 16.625 8.58579 16.625 9C16.625 9.41421 16.9608 9.75 17.375 9.75Z",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16965 11.7014C9.94762 13.2919 11.2369 14.5753 12.8309 15.346C12.9475 15.4013 13.0765 15.4252 13.2052 15.4155C13.3339 15.4058 13.4579 15.3627 13.5648 15.2905L15.9119 13.7254C16.0157 13.6562 16.1352 13.6139 16.2594 13.6025C16.3837 13.5911 16.5088 13.6109 16.6235 13.66L21.0144 15.5419C21.1636 15.6052 21.2881 15.7154 21.3693 15.8556C21.4504 15.9959 21.4838 16.1588 21.4643 16.3197C21.3255 17.4057 20.7956 18.4039 19.9739 19.1273C19.1521 19.8508 18.0948 20.2499 17 20.25C13.6185 20.25 10.3755 18.9067 7.98439 16.5156C5.5933 14.1245 4.25 10.8815 4.25 7.49997C4.25006 6.40513 4.64918 5.34786 5.37264 4.5261C6.0961 3.70435 7.09428 3.17448 8.18028 3.03569C8.34117 3.01622 8.50403 3.04956 8.64432 3.1307C8.78461 3.21183 8.89473 3.33636 8.9581 3.48552L10.8416 7.88032C10.8903 7.994 10.9101 8.11796 10.8994 8.24116C10.8886 8.36436 10.8475 8.48299 10.7798 8.58647L9.22011 10.9696C9.14912 11.0768 9.10716 11.2006 9.09831 11.3288C9.08947 11.4571 9.11405 11.5855 9.16965 11.7014V11.7014Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMobileIcon);
export default __webpack_public_path__ + "static/media/phone-mobile-icon.7948c76f31a704fb5e959ac34456301f.svg";
export { ForwardRef as ReactComponent };